import {BaseEntity} from '@bndes/bndes-ux4/bndes-angular-utils';

export class ModalidadeScrModel extends BaseEntity {

  codigoScrModalidade: number;
  nomeScrModalidade: string;
  tipoScrModalidade: ObjetivoFinanciamento;
  tipoCliente: string;
}

export interface ObjetivoFinanciamento {
  nome: string;
  valor: ObjetivoFinanciamentoEnum;
}

export enum ObjetivoFinanciamentoEnum {
  GIRO  = 'G',
  INVESTIMENTO = 'I'
}

export const ObjetivoFinanciamentoLista: ObjetivoFinanciamento[] = [
  {nome: 'Empréstimo/Capital de Giro', valor: ObjetivoFinanciamentoEnum.GIRO},
  {nome: 'Investimento', valor: ObjetivoFinanciamentoEnum.INVESTIMENTO}
];

export interface TipoCliente {
  nome: string;
  valor: TipoClienteEnum;
}

export enum TipoClienteEnum {
  CNPJ = "J",
	CPF = "F",
	AMBOS = "A"
}

export const TipoClienteLista: TipoCliente[] = [
  {nome: 'PF - Pessoa Física', valor: TipoClienteEnum.CPF},
  {nome: 'PJ - Pessoa Jurídica', valor: TipoClienteEnum.CNPJ},
  {nome: 'Ambos', valor: TipoClienteEnum.AMBOS},
];